module.exports = __webpack_public_path__ + "img/img17.31f521d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img17.jpg
// module id = 313
// module chunks = 0